import React from 'react';
import styles from './region-entity-table.module.scss';

const SCHOOL_TYPES = [
  'Primary',
  'Secondary',
  'Independent',
  'Combined',
  'Special',
];

export const InfoNotice = ({ entityOrRegion, comparing }) => {
  const [readMore, setReadMore] = React.useState(false);

  React.useEffect(() => {
    setReadMore(SCHOOL_TYPES.map((d) => false));
  }, [entityOrRegion]);

  return (
    <div>
      <p className={`${styles.cellInfoText} ${styles.tableInfoText}`}>
        {(entityOrRegion.name.includes('TAFE') ||
          entityOrRegion.name.includes('University')) && (
          <span>
            * Interstate, overseas or online campuses or other non-campus hubs
          </span>
        )}
        <br />
        ** Includes locations where education is delivered by third party
        providers
        <br />
        {entityOrRegion.name.includes('Griffith') && (
          <span>*** No FTEs have been apportioned to online delivery</span>
        )}
      </p>
      {(entityOrRegion.name.includes('TAFE') ||
        entityOrRegion.name.includes('Department of Employment')) && (
        <p className={`${styles.cellInfoText} ${styles.tableInfoText}`}>
          Department of Employment, Small Business and Training campuses are{' '}
          {entityOrRegion.name.includes('TAFE') && 'also '}provided for use by
          TAFE Queensland under a memorandum of understanding. TAFE Queensland
          also uses additional locations for vocational education and training,
          outside of those provided by the department.
        </p>
      )}
      <p className={`${styles.cellInfoText} ${styles.tableInfoText}`}>
        FTE — full time equivalents.
        {(entityOrRegion.name.includes('TAFE') ||
          entityOrRegion.name.includes('Department') ||
          entityOrRegion.name.includes('University') ||
          entityOrRegion.name.includes('Grammar')) &&
          ' EFTSL — equivalent full time student load.'}
      </p>
      {!comparing &&
        entityOrRegion.schoolsByRegion &&
        SCHOOL_TYPES.map((d, i) => {
          const schools = entityOrRegion.schoolsByRegion
            .filter((e) => e.schoolType === d)
            .map((e) => e.schoolName);

          return (
            <p className={`${styles.cellInfoText} ${styles.tableInfoText}`}>
              <sup className={styles.cellInfoSchoolType}>
                {['a', 'b', 'c', 'd', 'e'][i]}
              </sup>
              {schools.length === 0 && (
                <React.Fragment>{d + ' — None in this region.'}</React.Fragment>
              )}
              {schools.length > 0 && schools.length < 10 && (
                <React.Fragment>
                  {d + ' — ' + schools.join(', ')}
                </React.Fragment>
              )}
              {schools.length >= 10 && (
                <React.Fragment>
                  {d +
                    ' — ' +
                    schools
                      .slice(0, readMore[i] ? schools.length : 10)
                      .join(', ')}
                  {readMore[i] ? (
                    <span>
                      {' '}
                      <a
                        className={styles.readMore}
                        onClick={() =>
                          setReadMore(
                            SCHOOL_TYPES.map((e, j) =>
                              e === d ? false : readMore[j]
                            )
                          )
                        }
                      >
                        Show less
                      </a>
                    </span>
                  ) : (
                    <span>
                      {'... '}
                      <a
                        className={styles.readMore}
                        onClick={() =>
                          setReadMore(
                            SCHOOL_TYPES.map((e, j) =>
                              e === d ? true : readMore[j]
                            )
                          )
                        }
                      >
                        Show full list
                      </a>
                    </span>
                  )}
                </React.Fragment>
              )}
            </p>
          );
        })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/region-entity-table/info-notice.js